const K = (k) => `gh-recent:${k}`;

export const getRecent = (key) => { try { return JSON.parse(localStorage.getItem(K(key)) || "[]"); } catch { return []; } };
export const pushRecent = (key, v, max = 6) => {
  if (!v) return;
  localStorage.setItem(K(key), JSON.stringify([v, ...getRecent(key).filter((x) => x !== v)].slice(0, max)));
};

const D = (k) => `gh-draft:${k}`;
export const readDraft = (key) => { try { return JSON.parse(localStorage.getItem(D(key)) || "null"); } catch { return null; } };
export const writeDraft = (key, value) => localStorage.setItem(D(key), JSON.stringify({ value, at: Date.now() }));
export const clearDraft = (key) => localStorage.removeItem(D(key));
